import './index.scss'
import '../../assets/scripts/jquery.mousewheel'

$(document).ready(function(){
  getArticleH()
})
$(window).resize(function(){
  getArticleH()
})

function getArticleH(){
  if($(window).width()>1024){
    let articleH = $(window).height() - $('.article-cont .article-title').outerHeight() - $('.article-cont .article-info').outerHeight() - 50
    $('.article-cont .article').css('height', articleH + 'px')
  }
}


$('body').mousewheel(function (event,dat) {
  let footerH = $('.fixed-footer').outerHeight()
  if($(window).width() > 1024){
    let scroH = $('.article').scrollTop(); //滚动高度
    let viewH = Math.floor($('.article').outerHeight()); //可见高度
    let contentH = Math.floor($('.article .cont').outerHeight()); //内容高度
    if(dat == 1){
      // console.log('上翻隐藏footer')
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
    }else if(dat == -1){
      // console.log('下翻显示footer')
      if(contentH > viewH){
        if( contentH-(scroH + viewH) < 3){
          if(!$('.fixed-footer').hasClass('show')){
            $('.fixed-footer').addClass('show')
            $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
          }
        }
      }else{
        if(!$('.fixed-footer').hasClass('show')){
          $('.fixed-footer').addClass('show')
          $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
        }
      }
    }
  }
})